import { useState } from "react";
import { RiMenu2Line, RiMenu3Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const Navbar = ({ setIsCollapsed, isCollapsed }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  const handleProfileClick = () => {
    navigate("/profile");
  };

  return (
    <nav className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-white sticky top-0 w-full p-2 flex items-center shadow-xl z-50">
      <button 
        onClick={() => setIsCollapsed(!isCollapsed)} 
        className="text-lg p-1.5 hover:scale-105 transition-transform"
      >
        {isCollapsed ? (
          <RiMenu2Line className="text-xl text-white" />
        ) : (
          <RiMenu3Line className="text-xl text-white" />
        )}
      </button>

      <div className="flex justify-between items-center w-full">
        {/* Left Side - Empty for balance */}
        <div className="flex ml-2 items-center">
          {/* Empty for now */}
        </div>

        {/* Right Side - Logo with Profile Navigation */}
        <div className="flex items-center cursor-pointer group" onClick={handleProfileClick}>
          <div className="flex items-center gap-2">
            <div className="relative">
              <img
                className="rounded-full w-10 h-10 border-2 border-white/30 shadow-lg group-hover:border-white/50 transition-all duration-300 group-hover:scale-105"
                src="https://th.bing.com/th/id/R.896a4e414250d6674aab14bee5e48559?rik=mCDNX4WwaflN9g&pid=ImgRaw&r=0"
                alt="DreamToday Logo"
              />
              <div className="absolute inset-0 rounded-full bg-white/0 group-hover:bg-white/10 transition-all duration-300"></div>
            </div>
            <div className="flex flex-col">
              <h1 className="text-lg font-bold text-white tracking-wider group-hover:text-white/90 transition-all duration-300">
                DreamToday
              </h1>
              <p className="text-[8px] text-white/70 -mt-1">Admin Panel</p>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
    </nav>
  );
};

export default Navbar;